import request from "@/utils/request";

// 新增证书
export function saveCompcertificates(data) {
  return request({
    url: `/shop/compliance/compcertificates/save`,
    method: "POST",
    data,
  });
}

// 查询证书列表
export function getCompcertificates() {
  return request({
    url: `/shop/compliance/compcertificates/list`,
    method: "GET",
  });
}

// 查询全部证书列表
export function getCompcertificatesAllList() {
  return request({
    url: `/shop/compliance/compcertificates/allList`,
    method: "GET",
  });
}

// 查询证书列表
export function updateCompcertificates(data) {
  return request({
    url: `/shop/compliance/compcertificates/update`,
    method: "POST",
    data,
  });
}

// 删除证书
export function deleteCompcertificates(params) {
  return request({
    url: `/shop/compliance/compcertificates/delete`,
    method: "GET",
    params,
  });
}

// 保存资质字段
export function saveCompcertificatesfields(data) {
  return request({
    url: `/shop/compliance/compcertificatesfields/save`,
    method: "POST",
    data,
  });
}

// 修改资质字段
export function updateCompcertificatesfields(data) {
  return request({
    url: `/shop/compliance/compcertificatesfields/update`,
    method: "POST",
    data,
  });
}

// 删除资质字段
export function deleteCompcertificatesfields(params) {
  return request({
    url: `/shop/compliance/compcertificatesfields/delete`,
    method: "GET",
    params,
  });
}

// 查询资质字段列表
export function getCompcertificatesfieldsList() {
  return request({
    url: `/shop/compliance/compcertificatesfields/list`,
    method: "GET",
  });
}

// 查询客户类型列表
export function getListByType(params) {
  return request({
    url: `/shop/shoptype/getListByType`,
    method: "GET",
    params,
  });
}

//新增修改商铺类型
export function saveOrUpdateShopTp(data) {
  return request({
    url: `/shop/shoptype/saveOrUpdate`,
    method: "POST",
    data,
  });
}
// 商铺启用禁用
export function enableShopTp(params) {
  return request({
    url: `/shop/shoptype/enable`,
    method: "GET",
    params,
  });
}

//商铺类型删除
export function deleteShopTp(params) {
  return request({
    url: `/shop/shoptype/delete`,
    method: "GET",
    params,
  });
}

//根据商铺类型查询证书
export function getListByTypeCode(params) {
  return request({
    url: `/shop/compliance/compcertificates/getListByTypeCode`,
    method: "GET",
    params,
  });
}

//根据ids查询资质
export function queryByCertificateIds(data) {
  return request({
    url: `/shop/compliance/compcertifyconfig/queryByCertificateIds`,
    method: "POST",
    data,
  });
}

// 保存商铺资质
export function saveCertify(data) {
  return request({
    url: `/shop/shoptype/saveCertify`,
    method: "POST",
    data,
  });
}
// 根据 requestid 查询资质详情
export function getCertificationByRequestId(requestId) {
  return request({
    url: `/shop/compShopCertify/details/${requestId}`,
    method: "get",
    params: {},
  });
}
// 根据 shopId 查询商户资质详情（ops）
export function getOpsCertifyDetailsByShopId(shopId) {
  return request({
    url: `/shop/compShopCertify/ops/detailsNew`,
    method: "get",
    params: { shopId },
  });
}
// 查经营范围
export function queryScopeList() {
  return request({
    url: `/product/compBusinessScope/queryScopeList`,
    method: "POST",
  });
}

// 系统修改资质
export function compShopCertifyCommit(data) {
  return request({
    url: `/shop/compShopCertify/system/commit`,
    method: "POST",
    data,
  });
}

// 商铺审核
export function auditCompanyEdit(data) {
  return request({
    url: `/shop/shop/audit`,
    method: "put",
    data,
  });
}

// 查审核详情
export function getApproveDetail(logId) {
  return request({
    url: `/shop/shop/history/details/${logId}`,
    method: "get",
  });
}
// 查资质准备中的审核详情
export function getTempDataInfo(id) {
  return request({
    url: `/shop/compShopCertify/tempDataInfo/${id}`,
    method: "get",
  });
}
// 通过shopId查资质准备中的审核详情
export function getTempDataInfoByShopId(id) {
  return request({
    url: `/shop/compShopCertify/detailsByShopId/${id}`,
    method: "get",
  });
}
// 切换商户风险检查
export function switchRiskCheck(data) {
  return request({
    url: `/shop/shoptype/switchShopTypeRisk`,
    method: "get",
    params: data,
  });
}
//获取商户风险详情
export function getShopRiskDetail(params) {
  return request({
    url: `/shop/shopRisk/shopRiskDetail`,
    method: "get",
    params,
  });
}
